
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_784_12575)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M3.784 2.838V.946A.946.946 0 002.838 0H.946A.946.946 0 000 .946v1.892c0 .522.424.946.946.946h1.892a.946.946 0 00.946-.946zM3.784 7.946V6.054a.946.946 0 00-.946-.946H.946A.946.946 0 000 6.054v1.892c0 .522.424.946.946.946h1.892a.946.946 0 00.946-.946zM3.784 13.054v-1.892a.946.946 0 00-.946-.946H.946a.946.946 0 00-.946.946v1.892c0 .523.424.946.946.946h1.892a.946.946 0 00.946-.946zM6.388 2.838c-.269 0-.527-.1-.718-.277a.914.914 0 01-.297-.669c0-.25.107-.491.297-.669.19-.177.45-.277.718-.277h6.58c.269 0 .527.1.718.277.19.178.297.418.297.669 0 .25-.107.491-.297.669-.19.177-.449.277-.718.277h-6.58zM6.388 7.946c-.269 0-.527-.1-.718-.277A.914.914 0 015.373 7c0-.25.107-.491.297-.669.19-.177.45-.277.718-.277h6.58c.269 0 .527.1.718.277.19.178.297.418.297.67 0 .25-.107.49-.297.668-.19.177-.449.277-.718.277h-6.58zM6.388 13.054c-.269 0-.527-.1-.718-.277a.914.914 0 01-.297-.669c0-.25.107-.491.297-.669.19-.177.45-.277.718-.277h6.58c.269 0 .527.1.718.277.19.178.297.418.297.67 0 .25-.107.49-.297.668-.19.178-.449.277-.718.277h-6.58z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_784_12575"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    